import React from 'react';
import Button from '@mui/material/Button';
import type { ButtonProps } from '@mui/material/Button';
import { customButtonPalette } from '../../theme/palette.ts';

interface RoundedButtonProps extends ButtonProps {
  variantStyle: 'light' | 'dark';
	disabled?: boolean;
	width?: string | number;
}

const RoundedButton: React.FC<RoundedButtonProps> = ({
  variantStyle,
  children,
  onClick,
  variant,
	disabled,
	width,
  ...rest
}) => {
  const buttonStyling = customButtonPalette[variantStyle];
  return (
    <Button
      variant={variant}
      disableElevation
			disabled={disabled}
			data-disabled={disabled}
      sx={{
        backgroundColor: buttonStyling.backgroundColor,
        color: buttonStyling.color,
        borderRadius: '20px',
        padding: '8px 24px',
				minHeight: '37px',
				width: width || 'auto'
      }}
      role="button"
      onClick={onClick}
      {...rest}
    >
      {children}
    </Button>
  );
};

export default RoundedButton;
